<template>
  <div class="toast-host" aria-live="polite" aria-atomic="true">
    <transition-group name="toast" tag="div" class="toast-list">
      <div
        v-for="item in items"
        :key="item.id"
        class="toast"
        :class="'toast--' + item.type"
        :role="item.type === 'error' ? 'alert' : 'status'"
      >
        <span class="toast__icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path
              v-if="item.type === 'success'"
              d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
              fill="currentColor"
            />
            <path
              v-else-if="item.type === 'error'"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z"
              fill="currentColor"
            />
            <path
              v-else
              d="M12 2 1 21h22zm1 15h-2v-2h2zm0-4h-2V9h2z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span class="toast__message">{{ item.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastStore, clearAll } from '@/utils/toast'

export default {
  name: 'ToastHost',
  computed: {
    items() {
      return toastStore.items
    }
  },
  beforeDestroy() {
    // 宿主卸载时清掉所有待触发定时器，避免悬空
    clearAll()
  }
}
</script>

<style scoped>
.toast-host {
  position: fixed;
  top: var(--sp-5);
  left: 50%;
  transform: translateX(-50%);
  /* 高于移动端菜单与录音弹窗的 9999；tokens 无层级变量，按项目惯例硬编码 */
  z-index: 10000;
  width: 100%;
  padding: 0 var(--sp-4);
  display: flex;
  justify-content: center;
  /* 容器不拦截点击，只有提示条本身可交互 */
  pointer-events: none;
}

.toast-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
}

.toast {
  /* 默认（info / 未知类型）：中性浅底 */
  --toast-fg: var(--c-text-2);
  --toast-bg: var(--c-bg-soft);
  --toast-line: var(--c-line);

  display: flex;
  align-items: center;
  gap: var(--sp-2);
  min-width: 380px;
  max-width: min(90vw, 560px);
  padding: var(--sp-3) var(--sp-4);
  /* 整条填成浅色底，文字与图标同色 —— 对齐 element-ui Message 的观感 */
  color: var(--toast-fg);
  background: var(--toast-bg);
  border: 1px solid var(--toast-line);
  border-radius: var(--r-sm);
  box-shadow: var(--shadow-sm);
  font-family: var(--font-base);
  font-size: var(--fs-sm);
  line-height: var(--lh-snug);
  pointer-events: auto;
}

/* 三个状态整条换底换字；图标靠 fill="currentColor" 自动跟随文字色 */
.toast--success {
  --toast-fg: var(--c-success);
  --toast-bg: var(--c-success-bg);
  --toast-line: var(--c-success-line);
}
.toast--warning {
  --toast-fg: var(--c-warning);
  --toast-bg: var(--c-warning-bg);
  --toast-line: var(--c-warning-line);
}
.toast--error {
  --toast-fg: var(--c-error);
  --toast-bg: var(--c-error-bg);
  --toast-line: var(--c-error-line);
}

.toast__icon {
  flex-shrink: 0;
  display: inline-flex;
}

/* 后端可能返回较长中文，允许任意位置断行，避免横向溢出 */
.toast__message {
  word-break: break-word;
  overflow-wrap: anywhere;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.24s ease, transform 0.24s ease;
}
.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
/* 中间条目被移除时，下方的条平滑上移 */
.toast-move {
  transition: transform 0.24s ease;
}

@media (max-width: 480px) {
  .toast-host {
    top: var(--sp-3);
    padding: 0 var(--sp-3);
  }
  .toast {
    min-width: 0;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ToastHost.vue